import React, { Component, useEffect, useState, useRef } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";
import { getAlert } from "../Services/appAlerts";
import { getCurrentUser } from "../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { addAppNewMessage, appMessageAdded, getAddedMessageStatus, getLocalDocUploadSasUrl } from "../app/store/messages";
import { uploadFileToBlob } from "../Services/blobUploadService";

const ADD_MESSAGE_POPUP_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "6px",
  },
  sectionSubtitle: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    marginBottom: "14px",
  },
  dropZone: {
    border: "2px dashed rgba(148, 163, 184, 0.45)",
    borderRadius: "20px",
    padding: "30px 22px",
    textAlign: "center",
    background: "linear-gradient(180deg, rgba(248,250,252,0.88) 0%, rgba(255,255,255,1) 100%)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  dropZoneActive: {
    borderColor: "rgba(59, 130, 246, 0.7)",
    background: "linear-gradient(180deg, rgba(239,246,255,0.95) 0%, rgba(255,255,255,1) 100%)",
    boxShadow: "inset 0 0 0 1px rgba(147, 197, 253, 0.55)",
  },
  dropIcon: {
    width: "60px",
    height: "60px",
    margin: "0 auto 14px auto",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(79,70,229,0.16) 100%)",
    color: "#4338ca",
    fontSize: "26px",
  },
  dropTitle: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "6px",
  },
  dropText: {
    fontSize: "13px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  fileList: {
    display: "grid",
    gap: "12px",
  },
  fileRow: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "12px 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
  fileMeta: {
    minWidth: 0,
    flex: 1,
  },
  fileName: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
    wordBreak: "break-word",
  },
  fileSubtext: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  removeButton: {
    width: "34px",
    height: "34px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  textArea: {
    minHeight: "110px",
    borderRadius: "16px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "12px 14px",
    fontSize: "13px",
    color: "#0f172a",
    resize: "vertical",
    width: "100%",
    outline: "none",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
  },
  sendButtonDisabled: {
    opacity: 0.55,
    boxShadow: "none",
  },
};

const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes && sizeInBytes !== 0) return "";
  if (sizeInBytes < 1024) return `${sizeInBytes} B`;
  if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
};

const AddNewMessage = (props) => {
  const { addMsgShowHide, handleAddMsgModalShowHide, runningApplication } = props;

  const [documents, setDocuments] = useState([]);
  const [msg, setMsg] = useState("");
  const [btnSaveProcess, setBtnSaveProcess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const addedMessageStatusSelector = useSelector(getAddedMessageStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!addMsgShowHide) {
      setMsg("");
      setDocuments([]);
      setBtnSaveProcess(false);
      setIsDragging(false);
    }
  }, [addMsgShowHide])

  const onFileChange = async (event) => {
    const incomingDocs = Array.from(event.target.files || []).map((file) => ({
      name: file.name,
      type: file.type,
      size: file.size,
      file: file,
    }));
    if (incomingDocs.length === 0) return;
    setDocuments((prev) => [...prev, ...incomingDocs]);
    event.target.value = "";
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  // Drag & Drop Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map(file => ({
      name: file.name,
      type: file.type,
      size: file.size,
      file: file,
    }));
    setDocuments(prev => [...prev, ...docs]);
  };

  const handleMessageChange = ({ currentTarget }) => {
    setMsg(currentTarget.value);
  };

  const doSubmit = () => {
    setBtnSaveProcess(true);
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    const frmData = new FormData();
    frmData.append("workflowTask", JSON.stringify(runningApplication[0]));
    frmData.append("message", msg);
    frmData.append("userId", usrId);
    frmData.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));
    dispatch(addAppNewMessage(frmData));
  };

  useEffect(() => {
    if (addedMessageStatusSelector !== false && addedMessageStatusSelector !== null && addedMessageStatusSelector >= 0) {
      getAlert("", "Message Sent Successfully to Review Officer", "success");
      dispatch(appMessageAdded(null));
      setBtnSaveProcess(false);
      handleAddMsgModalShowHide("save");
    }
  }, [addedMessageStatusSelector])

  useEffect(() => {
    if (localDocUploadSasUrlSelector && localDocUploadSasUrlSelector?.length > 0) {
      documents.map((file, key) =>
        uploadFileToBlob(file.file, localDocUploadSasUrlSelector[key]?.uploadUrl, (progress) => {
          console.log(`Upload progress: ${progress}%`);
        })
      )
    }
  }, [localDocUploadSasUrlSelector]);

  const totalFiles = documents.length;
  const totalSize = documents.reduce((sum, item) => sum + (item.size || 0), 0);

  return (
    <Modal
      show={addMsgShowHide}
      size="xl"
      centered
      onHide={() => handleAddMsgModalShowHide("")}
      dialogClassName="add-message-popup-modal-dialog"
      contentClassName="add-message-popup-modal-content"
    >
      <style>
        {`
          .add-message-popup-modal-dialog {
            max-width: ${ADD_MESSAGE_POPUP_STYLES.modalDialog.maxWidth};
          }
          .add-message-popup-modal-content {
            border-radius: ${ADD_MESSAGE_POPUP_STYLES.modalContent.borderRadius};
            overflow: ${ADD_MESSAGE_POPUP_STYLES.modalContent.overflow};
            border: ${ADD_MESSAGE_POPUP_STYLES.modalContent.border};
            box-shadow: ${ADD_MESSAGE_POPUP_STYLES.modalContent.boxShadow};
          }
        `}
      </style>

      <Modal.Header style={ADD_MESSAGE_POPUP_STYLES.modalHeader}>
        <div style={ADD_MESSAGE_POPUP_STYLES.headerContent}>
          <Modal.Title as="div" style={ADD_MESSAGE_POPUP_STYLES.titleWrap}>
            <div style={ADD_MESSAGE_POPUP_STYLES.headerIcon}>
              <i className="fa fa-envelope" aria-hidden="true"></i>
            </div>
            <div>
              <div style={ADD_MESSAGE_POPUP_STYLES.title}>Add Message</div>
              <div style={ADD_MESSAGE_POPUP_STYLES.subtitle}>
                Send a message to the review officer, optionally including attachments.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={ADD_MESSAGE_POPUP_STYLES.closeButton}
            onClick={() => handleAddMsgModalShowHide("")}
            aria-label="Close add message popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={ADD_MESSAGE_POPUP_STYLES.modalBody}>
        <div style={ADD_MESSAGE_POPUP_STYLES.helperCard}>
          <div style={ADD_MESSAGE_POPUP_STYLES.helperTitle}>Messaging guidance</div>
          <p style={ADD_MESSAGE_POPUP_STYLES.helperText}>
            Type your message below. You can also drag files into the drop area or browse from your device to include attachments with your message.
          </p>
        </div>

        <div style={ADD_MESSAGE_POPUP_STYLES.sectionCard}>
          <div style={ADD_MESSAGE_POPUP_STYLES.sectionTitle}>Attachments</div>
          <div style={ADD_MESSAGE_POPUP_STYLES.sectionSubtitle}>
            {totalFiles > 0
              ? `${totalFiles} file${totalFiles > 1 ? "s" : ""} selected, ${formatFileSize(totalSize)} total`
              : "No files selected yet."}
          </div>

          <div
            style={{
              ...ADD_MESSAGE_POPUP_STYLES.dropZone,
              ...(isDragging ? ADD_MESSAGE_POPUP_STYLES.dropZoneActive : {}),
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <div style={ADD_MESSAGE_POPUP_STYLES.dropIcon}>
              <i className="fa fa-paperclip" aria-hidden="true"></i>
            </div>
            <div style={ADD_MESSAGE_POPUP_STYLES.dropTitle}>
              {isDragging ? "Drop files here" : "Drag and drop files here"}
            </div>
            <p style={ADD_MESSAGE_POPUP_STYLES.dropText}>
              {isDragging
                ? "Release to add the selected files."
                : "Or click anywhere in this area to browse and select documents."}
            </p>
          </div>
        </div>

        {documents.length > 0 && (
          <div style={ADD_MESSAGE_POPUP_STYLES.sectionCard}>
            <div style={ADD_MESSAGE_POPUP_STYLES.sectionTitle}>Selected attachments</div>
            <div style={ADD_MESSAGE_POPUP_STYLES.sectionSubtitle}>
              Review the files below before sending them.
            </div>

            <div style={ADD_MESSAGE_POPUP_STYLES.fileList}>
              {documents.map((file, index) => (
                <div key={`${file.name}-${index}`} style={ADD_MESSAGE_POPUP_STYLES.fileRow}>
                  <div style={ADD_MESSAGE_POPUP_STYLES.fileMeta}>
                    <div style={ADD_MESSAGE_POPUP_STYLES.fileName}>{file.name}</div>
                    <div style={ADD_MESSAGE_POPUP_STYLES.fileSubtext}>
                      {formatFileSize(file.size)}
                      {file.type ? ` | ${file.type}` : ""}
                    </div>
                  </div>
                  <button
                    type="button"
                    style={ADD_MESSAGE_POPUP_STYLES.removeButton}
                    onClick={() => handleFileRemove(file)}
                    aria-label={`Remove ${file.name}`}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={ADD_MESSAGE_POPUP_STYLES.sectionCard}>
          <div style={ADD_MESSAGE_POPUP_STYLES.sectionTitle}>Message</div>
          <div style={ADD_MESSAGE_POPUP_STYLES.sectionSubtitle}>
            Enter the content of your message.
          </div>
          <textarea
            name="msg"
            id="msg"
            className="form-control"
            value={msg}
            onChange={handleMessageChange}
            style={ADD_MESSAGE_POPUP_STYLES.textArea}
            placeholder="Type your message here..."
          ></textarea>
        </div>


        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          aria-label="Upload files"
          multiple
          style={{ display: "none" }}
        />
      </Modal.Body>
      <Modal.Footer style={ADD_MESSAGE_POPUP_STYLES.modalFooter}>
        <div style={ADD_MESSAGE_POPUP_STYLES.footerActions}>
          <button
            type="button"
            style={ADD_MESSAGE_POPUP_STYLES.cancelButton}
            onClick={() => handleAddMsgModalShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Cancel
          </button>
          <Button
            variant="outline-default"
            size="sm"
            style={{
              ...ADD_MESSAGE_POPUP_STYLES.sendButton,
              ...(btnSaveProcess ? ADD_MESSAGE_POPUP_STYLES.sendButtonDisabled : {}),
            }}
            onClick={doSubmit}
            disabled={btnSaveProcess}
          >
            <i
              className={`fa ${btnSaveProcess ? "fa-circle-o-notch fa-spin" : "fa-paper-plane-o"}`}
              aria-hidden="true"
            ></i>
            {btnSaveProcess ? "Sending..." : "Send"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}


export default AddNewMessage;
